import { render, staticRenderFns } from "./AccreditationsControl.vue?vue&type=template&id=46307bb4&"
import script from "./AccreditationsControl.vue?vue&type=script&lang=js&"
export * from "./AccreditationsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports